import { ModalWithForm } from '@/components/ats';
import { useRejectEmailFormConfig } from '@/formConfigs/useRejectEmailFormConfig';
import { CreateProjectDrawer } from '@/components/shared/project-modal/create-project-drawer';
import { useRef } from 'react';
import { useGetDefaultFrom } from '@/hooks';

export const RejectModal = ({
  rejectModalActions,
  handleSubmit = () => {},
  isLoading = false,
  actionApplication,
  initialValues = null,
  maxHeight = '70vh',
  isProjectCreationAllowed = true,
}) => {
  const { isOpen, onClose } = rejectModalActions;
  const formRef = useRef(null);
  const {
    rejectFormConfig,
    isCreateProjectOpen,
    handleModalClose,
    setCreatedProjectData,
  } = useRejectEmailFormConfig({
    isProjectCreationAllowed,
    isQuickAppReview: true,
    atsJobStageId: actionApplication?.job_stage_id,
  });

  const values = initialValues?.sendRejectEmail
    ? {
        reject_without_email: true,
        ats_rejection_reason_id: initialValues?.rejectionReason?.id,
        sendRejectEmail: initialValues?.sendRejectEmail,
        schedule_at: {
          formattedTime: initialValues?.scheduleAt,
          timezoneValue: initialValues?.timeZone,
        },
        ...initialValues,
      }
    : {
        reject_without_email: true,
        ats_rejection_reason_id: initialValues?.rejectionReason?.id,
      };

  const { from, fromUserObject } = useGetDefaultFrom({});

  if (from) {
    initialValues = {
      ...initialValues,
      from,
      ...(fromUserObject && { fromUserObject }),
    };
  }

  return (
    <>
      <ModalWithForm
        formConfig={rejectFormConfig({
          contact: actionApplication?.contact,
          initialValues,
        })}
        handleSubmit={handleSubmit}
        headerText="Reject candidate?"
        subHeaderText="Select a reason for rejecting this candidate"
        initialValues={{
          ...values,
        }}
        isCtaLoading={isLoading}
        isOpen={isOpen}
        enableBorder={true}
        modalRef={formRef}
        onClose={onClose}
        primaryCtaText="Reject"
        modalBodyProps={{ maxHeight: maxHeight, overflowY: 'scroll' }}
        modalHeaderProps={{ p: '12px 24px' }}
        modalSize="2xl"
      />
      <CreateProjectDrawer
        modalActions={{
          isOpen: isCreateProjectOpen,
          onClose: handleModalClose,
        }}
        setCreatedProjectData={setCreatedProjectData}
        mode="create"
      />
    </>
  );
};
